import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ITaxWithheld } from "@modules/taxes/domain/entities/taxes.model";

@Component({
	selector: "tax-amount-label",
	templateUrl: "./tax-label.component.html",
	styleUrls: ["./tax-success-amount-label.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TaxAmountLabelComponent {
	@Input() taxWithheld: Partial<ITaxWithheld> = null;
	@Input() type: "FIAT" | "ASSET" = "FIAT";
}
